import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index/index'
import Detail from '../views/detail/index'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Index,
        meta: {
            keepAlive: true // 需要被缓存
        }
    },{
        path: '/detail',
        component: Detail,
        meta:{
            keepAlive:false //不需要被缓存的组件
        }
    },
]

const createRouter = () => new VueRouter({
    scrollBehavior: () => ({
        y: 0
    }),
    routes
})

const router = createRouter()

export default router
